// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PersonalInformation_personalInformationContainer__Y6Y9g {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 450px;
}

.PersonalInformation_personalInformationInput__shmmC {
  max-width: 370px;
  height: 56px;
}

.PersonalInformation_personalInformationFormContainer__BZfXk {
  display: flex;
  flex-direction: column;
  max-width: 370px;
}

.PersonalInformation_personalInformationInputPasswordField__cAME\\+ {
  margin-bottom: 50px;
  max-width: 370px;
  height: 56px;
}

.PersonalInformation_personalImg__CdvzH {
  max-width: 50%;
}

.PersonalInformation_formContainer__S5z0K {
  margin-bottom: 50px;
}
.PersonalInformation_requiredTag__-X8jx {
  text-align: right;
}

.PersonalInformation_requiredRed__WXhkZ {
  color: var(--color-font-red);
}


`, "",{"version":3,"sources":["webpack://./src/@_pages/AccountCreation/components/PersonalInformation/PersonalInformation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".personalInformationContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 450px;\n}\n\n.personalInformationInput {\n  max-width: 370px;\n  height: 56px;\n}\n\n.personalInformationFormContainer {\n  display: flex;\n  flex-direction: column;\n  max-width: 370px;\n}\n\n.personalInformationInputPasswordField {\n  margin-bottom: 50px;\n  max-width: 370px;\n  height: 56px;\n}\n\n.personalImg {\n  max-width: 50%;\n}\n\n.formContainer {\n  margin-bottom: 50px;\n}\n.requiredTag {\n  text-align: right;\n}\n\n.requiredRed {\n  color: var(--color-font-red);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"personalInformationContainer": `PersonalInformation_personalInformationContainer__Y6Y9g`,
	"personalInformationInput": `PersonalInformation_personalInformationInput__shmmC`,
	"personalInformationFormContainer": `PersonalInformation_personalInformationFormContainer__BZfXk`,
	"personalInformationInputPasswordField": `PersonalInformation_personalInformationInputPasswordField__cAME+`,
	"personalImg": `PersonalInformation_personalImg__CdvzH`,
	"formContainer": `PersonalInformation_formContainer__S5z0K`,
	"requiredTag": `PersonalInformation_requiredTag__-X8jx`,
	"requiredRed": `PersonalInformation_requiredRed__WXhkZ`
};
export default ___CSS_LOADER_EXPORT___;
